import styled from 'styled-components';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Header = styled.div`
    display: grid;
    grid-template-columns: 2fr 0.5fr 1fr 1.5fr;
    min-height: 5.2rem;
    align-items: center;
    padding: 0.8rem;
    color: ${COLORS.textGray};
    font-size: 1.4rem;

    ${respondDown(Breakpoints.md)`display: none;`}
`;

export const Row = styled.div`
    display: grid;
    grid-template-columns: 2fr 0.5fr 1fr 1.5fr;
    align-items: center;
    min-height: 11.4rem;
    padding: 0.8rem;
    border-bottom: 0.1rem solid ${COLORS.gray100};

    > :last-child {
        justify-self: end;
    }

    ${respondDown(Breakpoints.md)`
        grid-template-columns: 1fr;
        gap: 2.4rem;
        background: ${COLORS.white};
        padding: 2.7rem 1.6rem 1.6rem;
        margin-bottom: 1.6rem;
        border-radius: 0.5rem;
        > :last-child { width: 100%; }
    `}
`;

export const Pair = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;

    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: flex-start;
    `}
`;

export const Value = styled.div`
    display: flex;
    align-items: center;
    gap: 1.6rem;
    > span {
        display: none;
    }

    ${respondDown(Breakpoints.md)`
        justify-content: space-between;
        > span { display: inline; color: ${COLORS.textGray}; }
    `}
`;
